// ContextMenuController.js
// Ref: https://github.com/dgoguerra/bootstrap-menu

import $ from 'jquery';

import BaseController       from 'BaseController.js';
import BootstrapMenu        from 'bootstrap-menu';
import constants            from 'Constants.js'
import listService          from 'ListService.js';
import crudController       from 'CrudController.js';
import alignmentController  from 'AlignmentController.js';


//======================================================================================
// Client of bootstrap-menu context menu.
// Ref:
// https://github.com/dgoguerra/bootstrap-menu
//======================================================================================
class ContextWorkflowMenuController extends BaseController {

    constructor() {
        super();
        this._menu = new BootstrapMenu(constants.CLASS_HAS_MENU, {

            fetchElementData: function ($elem) {                
                listService.countingValidObjects();
                return $elem;
            },

            //_actionSelectEvent: 'mousedown',

            //menuEvent: 'hover',

            /* Group actions by their id to create separators between
             * them in the context menu. Actions not appearing in a
             * group  appear in a default group. */
            actionsGroups: [
                ['cutItem', 'copyItem', 'pasteItem', 'deleteItem'],
                ['alignTop', 'alignRight', 'alignBottom', 'alignLeft'],
                ['sameWidth', 'sameHeight'],
                ['evenlySpaceAcross', 'evenlySpaceDown']
            ],

            actions: {
                cutItem: {
                    name: '<span class="context-item">Cut item</span><span class="keyboard-shortcut">Ctrl+x</span>',
                    onClick: function () {
                        crudController.copySelectedWorkflowObjects();
                        crudController.deleteSelectedWorkflowObjects();
                    },
                    isEnabled: function () {
                        return ( listService.areThereSelectedCanvasObjects && !listService.isCanvasSelected() && !listService.currentSelectedPathId);
                    }
                },
                copyItem: {
                    name: '<span class="context-item">Copy item</span><span class="keyboard-shortcut">Ctrl+c</span>',
                    onClick: function () {
                        crudController.copySelectedWorkflowObjects();
                    },
                    isEnabled: function () {
                        return ( listService.areThereSelectedCanvasObjects && !listService.isCanvasSelected() && !listService.currentSelectedPathId);
                    }
                },
                pasteItem: {
                    name: '<span class="context-item">Paste item</span><span class="keyboard-shortcut">Ctrl+v</span>',
                    onClick: function () {
                        listService.fcanvas.deactivateAll().renderAll();
                        crudController.pasteSelectedWorkflowObjects();
                    },
                    isEnabled: function () {
                        //return ((listService.workflowClipboard !== null) && (!listService.areThereSelectedCanvasObjects));
                        let val = false;
                        if (listService.workflowClipboard) {
                            val = true;
                        }

                        return val;
                    }
                },
                deleteItem: {
                    name: 'Delete item',
                    onClick: function () {
                        crudController.deleteSelectedWorkflowObjects();
                    },
                    isEnabled: function () {
                        return (listService.areThereSelectedCanvasObjects);
                    }
                },

                // -------------
                // align menu options
                // -------------

                alignTop: {
                    name: 'Align top',
                    onClick: function () {
                        alignmentController.canvasAlignTop( listService.fcanvas.getObjects() );
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },
                alignRight: {
                    name: 'Align right',
                    onClick: function () {
                        alignmentController.canvasAlignRight( listService.fcanvas.getObjects() );
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },
                alignBottom: {
                    name: 'Align bottom',
                    onClick: function () {
                        alignmentController.canvasAlignBottom( listService.fcanvas.getObjects() );
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },
                alignLeft: {
                    name: 'Align left',
                    onClick: function () {
                        alignmentController.canvasAlignLeft( listService.fcanvas.getObjects() );
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },

                // -------------
                // Make same menu options
                // -------------

                sameWidth: {
                    name: 'Make same width',
                    onClick: function () {
                        alignmentController.canvasMakeSameWidth(listService.fcanvas.getObjects());
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },
                sameHeight: {
                    name: 'Make same height',
                    onClick: function () {
                        alignmentController.canvasMakeSameHeight(listService.fcanvas.getObjects());
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },

                // -------------
                // Space evenly menu options
                // -------------

                evenlySpaceAcross: {
                    name: 'Space evenly across',
                    onClick: function () {
                        alignmentController.canvasSpaceEvenly( constants.EVENLY_ACROSS, listService.fcanvas.getObjects() );
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 2;
                    }
                },
                evenlySpaceDown: {
                    name: 'Space evenly down',
                    onClick: function () {
                        alignmentController.canvasSpaceEvenly( constants.EVENLY_DOWN, listService.fcanvas.getObjects() );
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 2;
                    }
                }
            }
        });

        // Send click to PF page if ESC pressed.
        $(constants.CONTENT_ID).on('keyup', this.handleKeyUp.bind(this));
        

    } // <-- end construtor()

    handleKeyUp(ev) {
        //console.log(ev);
        if (ev.keyCode === constants.KEY_ESC) {
            //console.log('ESC key');
            $(constants.CONTENT_ID).trigger('click');
        }
    }

    get menu() {
        return this._menu
    }

    remove() {
        $(constants.CONTENT_ID).off('keyup', handleKeyUp);
        this._menu.destroy();
        super.remove();
    }
}

export default ContextWorkflowMenuController;
